import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        overflow: 'hidden',
    },

    header:{
        display: "flex",
        alignItems: "center",
        flexWrap: 'wrap',
        gap: 24,
        minHeight: 55,
        flex: '0 0 auto',
        padding: 12,
        background: theme.colors.surface_alt,
        width: '100%',
        fontSize: 21,
        fontFamily: theme.font.secondary,
        fontWeight: 400,
        color: theme.colors.text_heading,
        textAlign: 'center',
    },

    stepWrap: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        minWidth: 0,
        gap: 10,
    },

    recapWrap: {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        gap: 10,
    },

    circle: {
        width: 29,
        height: 29,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        fontSize: 12,
        fontWeight: 700,
        background: theme.colors.border_subtle,
        color: theme.colors.grey_text,
        flex: "0 0 auto",
    },

    compStatus:{
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        gap: 8,
        padding: '8px 10px',
        borderRadius: 8,
        cursor: 'pointer',
        border: '1px solid transparent',
        background: 'transparent',

        '&:hover': {
            background: theme.colors.tab_white,
        },

        '&:focus-visible': {
            outline: `2px solid ${theme.colors.violet_primary}`,
            outlineOffset: 1,
        },
    },
    activeCompStatus: {
        background: theme.colors.tab_white,
        borderColor: theme.colors.violet_primary,
    },

    compSquare:{
        width: 18,
        height: 18,
        borderRadius: 4,
        marginRight: 5,
    },

    label: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        whiteSpace: "nowrap",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: "0 1 auto",
    },

    line: {
        height: 2,
        background: theme.colors.border_subtle,
        borderRadius: 999,
        flex: 1,
        minWidth: 12,
    },

    activeCircle: { background: theme.colors.violet_primary, color: theme.colors.white },
    activeLabel: { color: theme.colors.violet_primary },

    body: {
        display: 'flex',
        padding: '0 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(4),
        flex: '1 1 0',
        minHeight: 0,
        alignSelf: 'stretch',
        borderRadius: 4,
        overflowY: 'auto',
        overflowX: 'hidden',
        scrollBehavior: 'smooth',
    },
    compDataWrapper:{
        display: 'flex',
        alignItems: 'stretch',
        gap: theme.spacing(2),
        alignSelf: 'stretch',
        minWidth: 0,
        flex: '0 0 auto',
    },
    competencyWrapper:{
        display: 'flex',
        width: 'auto',
        flex: '0 1 clamp(240px, 24vw, 340px)',
        minWidth: 220,
        maxWidth: 360,
        padding: 24,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 24,
        alignSelf: 'stretch',
        borderRadius: 4,
        backgroundColor: theme.colors.white,
    },
    compHeaderContainer:{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        alignSelf: 'stretch',
    },
    compTitleContainer:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flex: '1 0 0',

        '& b':{
            color: theme.colors.text_heading,

            /* Title-Sub/Subtitle 1 */
            fontFamily: theme.font.secondary,
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
    },
    compCounterContainer:{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0,
        padding: '4px 8px',
        borderRadius: 999,
        background: theme.colors.grey_background,

        '& b':{
            color: theme.colors.text_heading,
            fontFamily: theme.font.secondary,
            fontSize: 13,
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },

        '& p':{
            color: theme.colors.text_heading,
            fontFamily: theme.font.secondary,
            fontSize: 13,
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
    },

    compDescriptionContainer:{
        alignSelf: 'stretch',

        color: theme.colors.text_heading,

        /* Body/M-Regular */
        fontFamily: theme.font.primary,
        fontSize: 15,
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 1.5,
    },
    gradingContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,

        '& b':{
            color: theme.colors.text_heading,

            /* Body/M-Bold */
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
    },
    gradingValueContainer:{
        display: 'flex',
        height: 28,
        padding: '8px 12px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        borderRadius: 4,
    },
    noValue:{
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
        lineHeight: 'normal',
    },
    itemList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
    },

    temRow: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        cursor: "pointer",

        "&:focus-visible": {
            outline: "2px solid rgba(91, 75, 183, 0.35)",
            outlineOffset: 2,
            borderRadius: 6,
        },

        "&$isChecked $temText": {
            color: theme.colors.text_heading,
        },

        "&$isChecked $temRadio": {
            borderColor: theme.colors.violet_primary,

            "&::after": {
                content: '""',
                position: "absolute",
                inset: 3,
                borderRadius: 999,
                background: theme.colors.violet_primary,
            },
        },
    },

    temRadio: {
        width: 16,
        height: 16,
        borderRadius: 999,
        border: `2px solid ${theme.colors.grey_darker}`,
        background: theme.colors.white,
        display: "inline-block",
        boxSizing: "border-box",
        position: "relative",
    },

    temText: {
        fontSize: 13,
        color: theme.colors.grey_text,
    },

    isChecked: {},

    notesContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 12,
        alignSelf: 'stretch',

        '& b':{
            color: theme.colors.text_heading,

            /* Body/M-Bold */
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
    },
    textInputContainer:{
        display: 'flex',
        height: 120,
        padding: 16,
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    textInput:{
        width: '100%',
        maxWidth: 440,
        minHeight: 92,
        padding: '10px 12px',

        fontSize: 13,
        lineHeight: '1.45',
        color: theme.colors.text_heading,
        background: theme.colors.white,

        border: `1px solid ${theme.colors.grey_light}`,
        borderRadius: 4,

        boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.03)',

        resize: 'both',
        outline: 'none',

        '$ :foucs':{
            borderColor: theme.colors.indigo_primary, /* light indigo */
            boxShadow:
                'inset 0 1px 0 rgba(0, 0, 0, 0.03), 0 0 0 2px rgba(99, 102, 241, 0.2)',
        },
    },

    behavioursContainer:{
        display: 'flex',
        padding: 24,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        flex: '1 1 460px',
        minWidth: 0,
        alignSelf: 'stretch',
        borderRadius: 4,
        backgroundColor: theme.colors.white,
    },

    behaviourContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderRadius: 4,
        background: theme.colors.surface_page,
    },
    behaviourHeader:{
        display: 'flex',
        padding: 16,
        alignItems: 'center',
        gap: 16,
        alignSelf: 'stretch',
    },
    behaviourCheckbox:{
        display: "flex",
        alignItems: "center",
        gap: 12,
    },
    titleContainer:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flex: '1 0 0',
        lineHeight: 1.4,
        color: theme.colors.text_heading,
    },
    behaviourCounter:{
        display: "flex",
        alignItems: "center",
        gap: 8,
    },

    behaviourDataContainer:{
        display: 'flex',
        padding: 16,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 16,
        alignSelf: 'stretch',
    },

    behaviourStepContainer:{
        display: 'flex',
        gap: 16,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },

    stepTitleContainer:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flex: '1 0 0',
        color: theme.colors.text_heading,
    },

    footer:{
        display: 'flex',
        minHeight: 72,
        width: '100%',
        boxSizing: 'border-box',
        padding: '12px 24px 16px',
        justifyContent: 'end',
        alignItems: 'center',
        alignSelf: 'stretch',
    },

    cancelButton:{
        display: 'flex',
        height: 40,
        minWidth: 40,
        padding: '0 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,
        background: 'rgba(233, 230, 239, 0.00)',
        borderWidth: 0,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,

        '&:hover':{
            background: theme.colors.tab_white,
        },
    },

    selectorControls:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },

    [theme.down('tablet')]: {
        body: {
            padding: '0 12px',
            gap: theme.spacing(2),
        },
        compDataWrapper: {
            flexDirection: 'column',
            gap: theme.spacing(1.5),
        },
        competencyWrapper: {
            flex: '0 0 auto',
            width: '100%',
            minWidth: 0,
            maxWidth: 'none',
            padding: 16,
        },
        behavioursContainer: {
            flex: '0 0 auto',
            width: '100%',
            padding: 16,
        },
        compTitleContainer: {
            '& b': {
                fontSize: 16,
            },
        },
        compDescriptionContainer: {
            fontSize: 14,
        },
    },
    backButton:{
        display: 'flex',
        height: 40,
        minWidth: 40,
        padding: '0 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        borderRadius: 4,
        background: theme.colors.tab_white,
        borderWidth: 0,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,

        '&:hover':{
            background: theme.colors.tab_white,
        },
    },
    nextButton:{
        display: 'flex',
        height: 40,
        minWidth: 40,
        padding: '0 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        borderRadius: 4,
        background: theme.colors.violet_primary,
        borderWidth: 0,
        color: theme.colors.white,
        fontFamily: theme.font.secondary,

        '&:hover':{
            background: theme.colors.tab_white,
        },
    },

    ccWrapper: {
        display: "inline-flex",
        alignItems: "center",
        gap: "0.5rem",
        cursor: "pointer",
        userSelect: "none",
    },

    ccWrapperDisabled: {
        cursor: "default",
        opacity: 0.6,
    },

    ccInput: {
        position: "absolute",
        opacity: 0,
        pointerEvents: "none",
    },

    ccBox: {
        width: 18,
        height: 18,
        borderRadius: 4,
        border: "2px solid transparent",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        lineHeight: 1,
        fontWeight: 700,
        transition: "all 0.15s ease-in-out",
    },

    ccCompBoxChecked:{
        backgroundColor: theme.colors.transp_violet,
    },

    ccCompBoxUnchecked:{
        backgroundColor: theme.colors.red_transparent,
    },

    ccBoxChecked: {
        borderColor: theme.colors.violet_primary,
        backgroundColor: theme.colors.violet_primary,
        color: theme.colors.white,
    },

    ccBoxUnchecked: {
        borderColor: theme.colors.violet_primary,
        color: theme.colors.error_text_dark,
    },

    ccLabel: {
        fontSize: "0.95rem",
        color: theme.colors.text_heading,
    },

    ccWrapperFocusWithin: {
        "&:focus-within $ccBox": {
            outline: `0px solid ${theme.colors.indigo_primary}`,
            outlineOffset: 2,
        },
    },
}));
